module.exports = __webpack_public_path__ + "img/4.c40e6ac5.png";